import PropTypes from 'prop-types';

import {
    BOTTOM_LC,
    BOTTOM_RC,
    RELATIVE_POSITION,
    TOP_LC,
    TOP_LC_M,
    TOP_LC_S,
    TOP_RC
} from './LabelContainer.config';
/** @namespace Bodypwa/Component/LabelContainer/Component/LabelContainerComponent */
export const LabelContainerComponent = ({ children, position = '', className = '' }) => {
    const positionClass = {
        [RELATIVE_POSITION]: 'relative',
        [BOTTOM_LC]: 'lg:bottom-2 bottom-1 lg:left-2 left-1',
        [TOP_LC_S]: 'lg:top-1 top-1 lg:left-1 left-1 ',
        [TOP_LC]: 'lg:top-2 top-1 lg:left-2 left-1 ',
        [TOP_RC]: 'lg:top-2 top-1 lg:right-2 right-1 ',
        [BOTTOM_RC]: 'lg:bottom-2 bottom-1 lg:right-2 right-1 ',
        [TOP_LC_M]: 'lg:left-3 lg:top-3 left-4 top-4 '
    };
    const absolutPosition = position === RELATIVE_POSITION ? '' : 'absolute';

    return (
        <div className={ `${className} ${positionClass[position]} ${absolutPosition} z-20` }>
            { children }
        </div>
    );
};
LabelContainerComponent.propTypes = {
    children: PropTypes.node.isRequired,
    position: PropTypes.string,
    className: PropTypes.string
};

export default LabelContainerComponent;
